import { Box, Button, Typography } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import ButtonCst from "@components/ButtonCst";

interface ConfirmModalCstInterface {
  title?: string;
  description?: string;
  firstChooseLabel?: string;
  secondChooseLabel?: string;
  firstChooseAction: () => void;
  secondChooseAction: () => void;
  onCancelAction: () => void;
}

const DoubleChooseModalCst: React.FC<ConfirmModalCstInterface> = ({
  title,
  description,
  onCancelAction,
  firstChooseLabel,
  secondChooseLabel,
  firstChooseAction,
  secondChooseAction,
}) => {
  return (
    <Box
      sx={{
        alignItems: "stretch",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ margin: "0" }} id="parent-modal-title">
          {title}
        </h2>
        <Button
          onClick={() => onCancelAction()}
          sx={{
            borderRadius: "50%",
            minWidth: "0",
            padding: "0 3px",
            display: "flex",
            justifyContent: "end",
            alignItems: "center",
            span: {
              width: "0",
            },
          }}
        >
          <CloseIcon fontSize="large" />
        </Button>
      </Box>
      <Typography
        id="parent-modal-description"
        variant="body2"
        sx={{
          mt: 5,
        }}
      >
        {description}
      </Typography>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          columnGap: "20px",
          rowGap: "10px",
          minHeight: "60px",
          mt: 2,
          alignItems: "end",
        }}
      >
        <ButtonCst
          id={"first-choose-button"}
          variant={"contained"}
          size={"medium"}
          onClick={() => {
            firstChooseAction?.();
          }}
        >
          {firstChooseLabel || ""}
        </ButtonCst>
        <ButtonCst
          id={"second-choose-button"}
          variant={"contained"}
          size={"medium"}
          onClick={() => {
            secondChooseAction?.();
          }}
        >
          {secondChooseLabel || ""}
        </ButtonCst>
      </Box>
    </Box>
  );
};

export default DoubleChooseModalCst;
